import { getSessionStorageAdapter } from './SessionStorageAdapter';
import { PageAPIData } from '../../../types/types';
import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';

export const resolveSessionStorageData = async ({
  flowAPI,
}: {
  flowAPI: ControllerFlowAPI;
}): Promise<PageAPIData | undefined> => {
  const sessionStorageAdapter = getSessionStorageAdapter({ flowAPI });
  const serviceId = sessionStorageAdapter.getServiceId()!;
  const slotAvailability = sessionStorageAdapter.getSlotAvailability();
  const timezone = sessionStorageAdapter.getTimezone()!;
  const dynamicPricePreSelection =
    sessionStorageAdapter.getDynamicPricePreSelection(
      slotAvailability?.slot?.serviceId!,
      slotAvailability?.slot?.startDate!,
    );
  const addonsInfoPreSelection = sessionStorageAdapter.getAddonsInfo();
  const resourceSelectionStrategy =
    sessionStorageAdapter.getResourceSelectionStrategy();

  return {
    serviceId,
    slotAvailability,
    timezone,
    dynamicPricePreSelection,
    addonsInfoPreSelection,
    resourceSelectionStrategy,
  };
};
